<template>
  <div id="input_delivery">
    <dd-header
      :isMenuView='false'
    />
    <dd-sitemap
      :pageKey="pageKey"
      :pageList="topForm.pageList"
    />
    <div class="container">
      <section>
        <div class="title">
          <h1>事前現場調査先入力画面</h1>
        </div>
        <div class="input_list">
          <dd-business-input
            ref="businessInputRef"
            :label="label"
            :form="form"
          />
          <ul>
            <li>
              <div>
                <span>{{label.contactFlag}}</span>
                <span class="important small_text">必須</span>
              </div>
              <div>
                <input type="radio" id="contact_1" name="contact" :value="1" v-model="form.contactFlag">
                <label for="contact_1" class="radio-label bold">あり</label>
                <input type="radio" id="contact_2" name="contact" :value="0" v-model="form.contactFlag">
                <label for="contact_2" class="radio-label bold">なし</label>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="Object.keys(errors).length > 0" class="error_text">入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。</div>
        <div class="control_btn_area">
          <div class="detail_btn2" @click="prev()">〈〈&nbsp;&nbsp;&nbsp;戻る&nbsp;&nbsp;&nbsp;</div>
          <div :class="{detail_btn: true, disabled: !isConfirm}" @click="confirm()">現場調査情報入力</div>
        </div>
      </section>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'

import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import Calendar from '../../components/common/Calendar'
import LoadingModal from '../../components/common/LoadingModal'
// Module
import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import SiteMap from '../components/common/DcSiteMap'
import BusinessInput from '../components/order/DcBusinessInput'

export default {
  name: 'OrderInput',
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-sitemap': SiteMap,
    'dd-calendar': Calendar,
    'dd-loading-modal': LoadingModal,
    'dd-business-input': BusinessInput
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      pageKey: 'orderInput',
      form: {
        businessId: '',
        businessName: '',
        building: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        tel: '',
        deliveryDate: '',
        message: '',
        selectTime: 0,
        isRegistAddress: false,
        contactFlag: 1
      },
      // 入力保持用のフォーム
      topForm: {},
      // 画面表示項目
      label: {
        businessName: '施主名(物件名)',
        building: '調査物件名',
        address: '以下、住所',
        postcd: '郵便番号',
        state: '住所',
        street: '以下、住所',
        userName: '立会人氏名',
        userNameKana: '立会人氏名（カナ）',
        tel: '立会人電話番号',
        contactFlag: '立会人への直接連絡',
        message: '配送時の連絡事項'
      },
      errors: {}
      // カレンダーの設定
      // schedule: {}
    }
  },
  methods: {
    // scheduling: function () {
    //   let payload = {
    //     params: {
    //       categoryId: this.topForm.categoryId
    //     }
    //   }
    //   axios.get(DC_URL.SCHEDULE + '/delivery', payload)
    //     .then(response => {
    //       this.schedule = response.data.data
    //     }).catch(error => {
    //       this.validateErrorMessages = {}
    //       Api.handleError(error, this.errorMessage, this.validateErrorMessages)
    //       this.$router.push('/error')
    //       this.$refs.loadingModalRef.showModal(false)
    //     })
    // },
    prev: function () {
      this.$router.go(-1)
    },
    selectedDate: function (selectedDate) {
      let format = 'YYYY-MM-dd'.replace(/YYYY/g, selectedDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (selectedDate.getMonth() + 1)).slice(-2))
      format = format.replace(/dd/g, ('0' + selectedDate.getDate()).slice(-2))
      this.form.deliveryDate = format
    },
    confirm: function () {
      this.$refs.loadingModalRef.showModal(true)
      // 入力チェック
      let retBusinessErr = this.$refs.businessInputRef.confirm()
      this.errors = {}
      this.validateRequire()
      if (!retBusinessErr || Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        return
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        return
      }

      // 入力内容をストレージに格納
      App.setLocalStorage(DC_STORAGE_KEY.RESEARCH_DATA, this.form)
      // 配送料込みの値段を取得する
      let payload = {
        resrchBusinessName: this.form.businessName,
        resrchBuilding: this.form.building,
        resrchPostcd: this.form.postcd,
        resrchState: this.form.state,
        resrchCity: this.form.city,
        resrchStreet: this.form.street,
        resrchUserLastName: this.form.userLastName,
        resrchUserFirstName: this.form.userFirstName,
        resrchUserLastNameKana: this.form.userLastNameKana,
        resrchUserFirstNameKana: this.form.userFirstNameKana,
        resrchTel: this.form.tel
      }
      axios.post(DC_URL.ORDER + '/resrch', payload)
        .then(response => {
          if (response.data.errorMessage) {
            App.showModal({
              messages: [response.data.errorMessage]
            })
            this.$refs.loadingModalRef.showModal(false)
          } else {
            this.$router.push('/research/input')
          }
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/error')
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    fetchData: function () {
      let ltop = App.getLocalStorage(DC_STORAGE_KEY.TOP_FORM)
      if (Object.keys(ltop).length > 0) {
        this.topForm = Object.assign({}, ltop)
        this.$set(this.form, 'postcd', this.topForm.postcd)
        this.$set(this.form, 'state', this.topForm.state)
        this.$set(this.form, 'city', this.topForm.city)
        this.$set(this.form, 'street', this.topForm.street)
      }
      let lform = App.getLocalStorage(DC_STORAGE_KEY.RESEARCH_DATA)
      if (Object.keys(lform).length > 0) {
        this.form = Object.assign({}, lform)
      }
      let lSelBusiness = App.getLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
      if (Object.keys(lSelBusiness).length > 0) {
        this.form = Object.assign(this.form, lSelBusiness)
      }
    },
    validateRequire: function () {
    },
    validateFormat: function () {
    }
  },
  computed: {
    isConfirm: function () {
      if (this.form.postcd && this.form.state && this.form.city) {
        return true
      }
      return false
    }
  },
  watch: {
  },
  mounted () {
    // this.scheduling()
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcBuildingResearchBusiness.vue